import React, { useState, useEffect } from 'react';

const COLORS = {
  primary: "#0760ad",
  primaryLight: "#098a48",
  secondary: "#118a94",
  secondaryLight: "#339166",
  white: "#FFFFFF",
};

const DEFAULT_DATA = {
  headerText: "About Warm Wellness Center",
  title: "Compassionate Care, Exceptional Results",
  description: "At WarmWellness Center, we've been redefining healthcare since 2010...",
  values: [
    { title: "Our Mission", text: "To provide healthcare that treats the whole person..." },
    { title: "Our Vision", text: "A community where wellness is accessible to all" },
    { title: "Our Promise", text: "Compassionate, competent care at every visit" }
  ]
};

const About1 = ({ isAdmin = false, onEdit }) => {
  const [aboutData, setAboutData] = useState(DEFAULT_DATA);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/about/about1/`);
        if (response.ok) {
          const data = await response.json();
          setAboutData(data);
        } else {
          console.error('Failed to fetch about data');
        }
      } catch (error) {
        console.error('Error fetching about data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (isLoading) {
    return (
      <div className="w-full py-20 px-4 sm:px-6 lg:px-8 bg-white text-justify">
        <div className="max-w-4xl mx-auto text-center">
          <span className="loading loading-spinner loading-lg"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full py-20 px-4 sm:px-6 lg:px-8 bg-white text-justify">
      <div className="max-w-4xl mx-auto text-center ">
        {/* Section Header */}
        <div className="mb-2">
          <span className="inline-block px-3 py-1 text-sm font-semibold rounded-full" 
                style={{ backgroundColor: COLORS.primaryLight, color: COLORS.white }}>
            {aboutData.headerText || "About Warm Wellness Center"}
          </span>
        </div>
        
        {/* Main Title */}
        <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: COLORS.primary }}>
          {aboutData.title || "Compassionate Care, Exceptional Results"}
        </h1>
        
        {/* Introductory Paragraph */}
        <p className="text-xl leading-relaxed mb-8 text-gray-700">
          {aboutData.description || "At WarmWellness Center, we've been redefining healthcare since 2010..."}
        </p>
        
        {/* Decorative Divider */}
        <div className="flex justify-center mb-12">
          <div className="w-20 h-1 rounded-full" style={{ backgroundColor: COLORS.secondary }}></div>
        </div>
        
        {/* Core Values */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {aboutData.values?.map((item, index) => (
            <div key={index} className="p-6 rounded-lg bg-gray-50 hover:shadow-md transition-all">
              <h3 className="text-lg font-semibold mb-2" style={{ color: COLORS.primary }}>
                {item.title || "Our Value"}
              </h3>
              <p className="text-gray-600">{item.text || "Description of this value"}</p>
            </div>
          ))}
        </div>

        {isAdmin && (
          <div className="mt-8">
            <button 
              onClick={onEdit}
              className="btn btn-primary"
            >
              Edit About Section
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default About1;